import React from 'react'

const WS = () => {
  return (
    <div>WS</div>
  )
}

export default WS